import { withChartLayout } from 'components/common';
import PsychosocialAssessment from 'components/features/chart/system-assessment/psychosocial-assessment/PsychosocialAssessment';

const PsychosocialAssessmentPage = withChartLayout('Psychosocial Assessment')(PsychosocialAssessment);
export default PsychosocialAssessmentPage;
